export default __webpack_public_path__ + "static/media/contact.ee6e2447.jpeg";